
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import TableCell from '@material-ui/core/TableCell';
import { Co2service } from '../../services/bunkermaster/Co2service';
import { HfoCalculationService } from '../../services/bunkermaster/HfoCalculationService';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { toast } from 'react-toastify';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Icon from '@material-ui/core/Icon';


import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    btn3: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '250px !important'
    },
    btn4: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important',
        position: 'relative',
        left: '600px'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function MGOCalculation() {

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [Mgo, setMgo] = React.useState({

        MCR_mainengine: "29400",
        Actualload_mainengine: "",
        MCR_AE1: "1200",
        Actualload_AE1: "",
        MCR_AE2: "1200",
        Actualload_AE2: "",
        MCR_AE3: "1200",
        Actualload_AE3: "",
        ActualFOconsumed_mainengine: "",
        ActualFOconsumed_AE1: "",
        ActualFOconsumed_AE2: "",
        ActualFOconsumed_AE3: "",
        FOcon_mainengine: "173.84",
        FOcon_AE1: "190",
        FOcon_AE2: "190",
        FOcon_AE3: "190",
        TotalMinutes: "",
        ActualCalorificValue: "",
        CvFromSeatrials: "",
        BDR_CV: "",
        CO2_Emissions_Actaul: "",
        CO2basedonAnnex_Mgo: "3.206",
        sea_state: 1, 
        load_condition: 1 
    })
   
    const [mgoresult, setMgoResult] = React.useState({ ACR_mainengine: "", ACR_AE1: "", ACR_AE2: "", ACR_AE3: "", ExpectedFO_mainengine: "", ExpectedFO_AE1: "", ExpectedFO_AE2: "", ExpectedFO_AE3: "", Total_ActualFOconsumed: "", Total_ExpectedFO: "", CO2_Emissions_Actaul: "", CO2_Emissions_High_CV_fuel: "", Excess_CO2: "", });
    const MgoCalculation = () => {
        
        let result = Co2service.CalculateMgo(
            Mgo
        )
        setMgoResult({ ...mgoresult, ...result });
    }
    const onFieldChange = (value, field) => {
        
        let local = Mgo;
        local[field] = value;
        setMgo({ ...Mgo, ...local });
    }
    const MgoReset = () => {
        
        setMgoResult({ ...mgoresult, ...{ ACR_mainengine: "", ACR_AE1: "", ACR_AE2: "", ACR_AE3: "", ExpectedFO_mainengine: "", ExpectedFO_AE1: "", ExpectedFO_AE2: "", ExpectedFO_AE3: "", Total_ActualFOconsumed: "", Total_ExpectedFO: "", CO2_Emissions_Actaul: "", CO2_Emissions_High_CV_fuel: "", Excess_CO2: "" } })
        setMgo({
            ...Mgo, ...{
                Actualload_mainengine: "",
                Actualload_AE1: "",
                Actualload_AE2: "",
                Actualload_AE3: "",
                ActualFOconsumed_mainengine: "",
                ActualFOconsumed_AE1: "",
                ActualFOconsumed_AE2: "",
                ActualFOconsumed_AE3: "",
                TotalMinutes: ""
            }
        })
    }
    return (
        <div className={classes.root}>
            {/* <TabPanel value={value} index={0} className="custom-tab-section"> */}
            <Accordion className="mainaccord pt20 " expanded={true}>
                <AccordionSummary

                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Ship Details</Typography>
                </AccordionSummary>
                <AccordionDetails open>
                    <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                        <div className={classes.root}>
                            <Grid container spacing={3}>

                                <Grid item xs={12} sm={6} md={4}>
                                    <Paper className={classes.paper}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >Ship Name  </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput className="width200"
                                                    // type="number"
                                                />   </Paper>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label > IMO </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput className="width200" type="number" />   </Paper>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >  Sample No.. </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput className="width200"  />   </Paper>
                                            </Grid>

                                        </Grid>


                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Paper className={classes.paper}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >Voyage Start </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput className="c_datewidth" type="date" /> 

                                                </Paper>
                                            </Grid>

                                        </Grid>

                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label > Start Port Name </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput />  &nbsp;           &nbsp;

                                                </Paper>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >Sea State  </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}>
                                                    <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                                        // onChange={(e) => oninputChange(e.target.value, "sea_state")}
                                                        value={Mgo.sea_state}
                                                    >
                                                        <MenuItem value={1}>Calm</MenuItem>
                                                        <MenuItem value={2}>Smooth</MenuItem>
                                                        <MenuItem value={3}>Slight</MenuItem>
                                                    </Select>
                                                </Paper>

                                            </Grid>

                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={6} sm={6} md={3}>
                                    <Paper className={classes.paper}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >Voyage End  </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput className="c_datewidth" type="date"
                                                //onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                />    </Paper>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >End Port Name </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}><BootstrapInput
                                                //onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                />  &nbsp;       &nbsp; </Paper>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} md={5}>
                                                <Paper className={classes.paper}>  <label >Load Condition  </label></Paper>
                                            </Grid>

                                            <Grid item xs={12} md={7}>
                                                <Paper className={classes.paper}>
                                                    <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                                        //onChange={(e) => oninputChange(e.target.value, "load_condition ")}
                                                        value={Mgo.load_condition}
                                                    >
                                                        <MenuItem value={1}>Loaded</MenuItem>
                                                        <MenuItem value={2}>Ballast</MenuItem>
                                                        <MenuItem value={3}>Part Loaded</MenuItem>
                                                    </Select>
                                                </Paper>
                                            </Grid>

                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={6} sm={6} md={2} className="pos_relative">
                                    <Paper className={classes.paper}>

                                        <Box
                                            className="pos_relative_img shipimg"
                                            component="img"
                                            display="block"
                                            height="100%"
                                            width="auto"
                                            align="right"

                                            src={
                                                process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                                                "assets/images/CO2-ship.jpg"
                                            }
                                        />


                                    </Paper>
                                </Grid>
                            </Grid>
                        </div>
                    </FormControl>
                </AccordionDetails>
            </Accordion>
            <Box component="div">
                <Grid item xs={12} md={12} className="padbtm0">
                    <p className="subtitle">Fuel Type</p>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Grid container spacing={3}  >
                        <Grid item xs={12} md={8}>


<table>
   <tr>
      <td> </td>
      <td> <label for="Density" className="widthauto" >MCR (kW) <span className="redstar">*</span>  </label> </td>
      <td> <label for="Density" className="widthauto" >Actaul Load <span className="redstar">*</span>  </label> </td>
      <td> <label for="Density" className="widthauto" >Actual Load in MCR    </label></td>
      <td>  <label for="Density" className="widthauto" >Actual FO consumed  <span className="redstar">*</span>  </label></td>
      <td>  <label for="Density" className="widthauto" >Expected FO </label></td>
      <td>  <label for="Density" className="widthauto" >FO con on 100% MCR </label></td>
   </tr>
   <tr>
      <td>
         <p className="subtitle padbtm0 ">M/E</p>
      </td>
      <td> <BootstrapInput type="number" className="width80"
         // className={fieldClass.ME_MCR ? "mt0" : "error"}
         value={Mgo.MCR_mainengine}
         /> 
      </td>
      <td>
         <BootstrapInput type="number" className="width80"
            onChange={(e) =>
         onFieldChange(e.target.value, "Actualload_mainengine")}
         value={Mgo.Actualload_mainengine}
         /> 
      </td>
      <td>
         <BootstrapInput type="number" disabled className="disabled width80"
            value={mgoresult.ACR_mainengine}
            />
         <span> %</span> 
      </td>
      <td> <BootstrapInput type="number" className="width80"
         //className={fieldClass.ME_FOconsumed ? "mt0 " : "error"}
         onChange={(e) => onFieldChange(e.target.value, "ActualFOconsumed_mainengine")}
         value={Mgo.ActualFOconsumed_mainengine}
         /> <span> Tonnes</span> 
      </td>
      <td>
         <BootstrapInput type="number" disabled className="disabled width80"
            value={mgoresult.ExpectedFO_mainengine}
            />
         <span> Tonnes</span> 
      </td>
      <td><BootstrapInput type="number" className="width80"
         // className={fieldClass.ME_FOMCR ? "mt0" : "error"}
         //onChange={(e) => onFieldChange(e.target.value, "ME_FOMCR")}
         value={Mgo.FOcon_mainengine}
         /> <span> g/kWh</span> 
      </td>
   </tr>
   <tr>
      <td>
         <p className="subtitle padbtm0">A/E No.1</p>
      </td>
      <td>   <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE1_MCR ? "mt0" : "error"}
         //onChange={(e) => onFieldChange(e.target.value, "MCR_AE1")}
         value={Mgo.MCR_AE1}
         /> 
      </td>
      <td><BootstrapInput type="number" className="width80"
         //className={fieldClass.AE1_Actualload ? "mt0" : "error"}
         onChange={(e) => onFieldChange(e.target.value, "Actualload_AE1")}
         value={Mgo.Actualload_AE1}
         /> 
      </td>
      <td>  <BootstrapInput type="number" disabled className="disabled width80 "
         // className={fieldClass.AE1_ActualloadMCR ? "mt0 disabled" : "error"}
         // onChange={(e) => onFieldChange(e.target.value, "AE1_ActualloadMCR")}
         value={mgoresult.ACR_AE1}
         /><span> %</span>
      </td>
      <td> <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE1_ActualFO ? "mt0" : "error"}
         onChange={(e) => onFieldChange(e.target.value, "ActualFOconsumed_AE1")}
         value={Mgo.ActualFOconsumed_AE1}
         /> <span> Tonnes</span> 
      </td>
      <td> <BootstrapInput type="number" disabled className="disabled width80"
         //className={fieldClass.AE1_ExpectedFO ? "mt0 disabled" : "error"}
         value={mgoresult.ExpectedFO_AE1}
         /><span> Tonnes</span>
      </td>
      <td>  <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE1_FOMCR ? "mt0" : "error"}
         //onChange={(e) => onFieldChange(e.target.value, "AE1_FOMCR")}
         value={Mgo.FOcon_AE1}
         /> <span> g/kWh</span> 
      </td>
   </tr>
   <tr>
      <td>
         <p className="subtitle padbtm0">A/E No.2</p>
      </td>
      <td> <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE2_MCR ? "mt0" : "error"}
         //onChange={(e) => onFieldChange(e.target.value, "MCR_AE2")}
         value={Mgo.MCR_AE2}
         /> 
      </td>
      <td>  <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE2_Actualload ? "mt0" : "error"}
         onChange={(e) => onFieldChange(e.target.value, "Actualload_AE2")}
         value={Mgo.Actualload_AE2}
         />
      </td>
      <td> <BootstrapInput type="number" disabled className="disabled width80"
         // className={fieldClass.AE2_ActualloadMCR ? "mt0 disabled" : "error"}
         // onChange={(e) => onFieldChange(e.target.value, "AE2_ActualloadMCR")}
         value={mgoresult.ACR_AE2}
         /><span> %</span> 
      </td>
      <td><BootstrapInput type="number" className="width80"
         //className={fieldClass.AE2_ActualFO ? "mt0" : "error"}
         onChange={(e) => onFieldChange(e.target.value, "ActualFOconsumed_AE2")}
         value={Mgo.ActualFOconsumed_AE2}
         /> <span> Tonnes</span> 
      </td>
      <td>  <BootstrapInput type="number" disabled className="disabled width80"
         // className={fieldClass.AE2_ExpectedFO ? "mt0 disabled" : "error"}
         value={mgoresult.ExpectedFO_AE2}
         /><span> Tonnes</span>
      </td>
      <td> <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE2_FOMCR ? "mt0" : "error"}
         // onChange={(e) => onFieldChange(e.target.value, "AE2_FOMCR")}
         value={Mgo.FOcon_AE2}
         /> <span> g/kWh</span> 
      </td>
   </tr>
   <tr>
      <td>
         <p className="subtitle padbtm0">A/E No.3</p>
      </td>
      <td> <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE2_MCR ? "mt0" : "error"}
         //onChange={(e) => onFieldChange(e.target.value, "MCR_AE3")}
         value={Mgo.MCR_AE3}
         /> 
      </td>
      <td>  <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE3_Actualload ? "mt0" : "error"}
         onChange={(e) => onFieldChange(e.target.value, "Actualload_AE3")}
         value={Mgo.Actualload_AE3}
         />
      </td>
      <td>  <BootstrapInput type="number" disabled className="disabled width80"
         // className={fieldClass.AE3_ActualloadMCR ? "mt0 disabled" : "error"}
         // onChange={(e) => onFieldChange(e.target.value, "AE3_ActualloadMCR")}
         value={mgoresult.ACR_AE3}
         /><span> %</span>
      </td>
      <td> <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE3_ActualFO ? "mt0" : "error"}
         onChange={(e) => onFieldChange(e.target.value, "ActualFOconsumed_AE3")}
         value={Mgo.ActualFOconsumed_AE3}
         /><span> Tonnes</span>
      </td>
      <td>  <BootstrapInput type="number" disabled className="disabled width80"
         //className={fieldClass.AE3_ExpectedFO ? "mt0 disabled" : "error"}
         value={mgoresult.ExpectedFO_AE3}
         /><span> Tonnes</span>
      </td>
      <td>  <BootstrapInput type="number" className="width80"
         //className={fieldClass.AE3_FOMCR ? "mt0" : "error"}
         value={Mgo.FOcon_AE3}
         /><span> g/kWh</span>
      </td>
   </tr>
   <tr>
      <td>
         <p className="subtitle padbtm0  " ><b>Total</b></p>
      </td>
      <td> </td>
      <td> </td>
      <td> </td>
      <td>
         <BootstrapInput type="number" disabled className="disabled  width80"
            value={mgoresult.Total_ActualFOconsumed}
            />
      </td>
      <td><BootstrapInput type="number" suffix={"%"} disabled className="disabled  width80" 
         value={mgoresult.Total_ExpectedFO}
         /> <span> Tonnes</span>
      </td>
      <td> </td>
   </tr>
</table>
 

                              




                            
                        </Grid>
                        <Grid item xs={12} md={4}>

                            <Box component="div" className="resultbox">
                                <p>Average Calorific value, 2021 from VPS database</p>
                                <Box component="div" className="bunkarinput wid180  mar25">

                                    <form className={classes.root} noValidate autoComplete="off">

                                        <Box component="div" className="">
                                            <label className=" width120">HFO   </label>

                                            <BootstrapInput value={"40.14"} readOnly className="smallbox1" />  &nbsp;     kJ/g
                                        </Box>
                                        <Box component="div" className="">
                                            <label className="  ">ULSFO   </label>
                                            <BootstrapInput value={"42.46"} readOnly className="smallbox1" />   &nbsp;   kJ/g

                                        </Box>
                                        <Box component="div" className="">
                                            <label className=" ">Distillate Fuel (MGO)   </label>

                                            <BootstrapInput value={"42.68"} readOnly className="smallbox1" />  &nbsp;    kJ/g

                                        </Box>
                                        <Box component="div" className="">
                                            <label className=" ">VLSFO  </label>

                                            <BootstrapInput value={"41.68"} readOnly className="smallbox1" />  &nbsp;   kJ/g

                                        </Box>
                                    </form>
                                </Box>
                            </Box>
                        </Grid>


                        <Grid item xs={12} md={12}>
                            <Grid container spacing={3} className=' flexbox vlsobox'  >
                                <Grid item xs={12} md={4}>
                                    <Box component="div" className="resultbox">
                                        <Box component="div" className="bunkarinput wid210  mar25">
                                            <form className={classes.root} noValidate autoComplete="off">
                                                <Box component="div" className="">
                                                    <label className=" width120">Total minutes   </label>

                                                    <BootstrapInput className="smallbox1"
                                                        onChange={(e) => onFieldChange(e.target.value, "TotalMinutes")}
                                                        value={Mgo.TotalMinutes}
                                                    />  &nbsp;     Minutes
                                                </Box>
                                                <Box component="div" className="">
                                                    <label className="  ">Actual Calorific Value (CV)   </label>
                                                    <BootstrapInput className="smallbox1"

                                                        onChange={(e) => onFieldChange(e.target.value, "ActualCalorificValue")}
                                                    />   &nbsp;  MJ/kg

                                                </Box>
                                                <Box component="div" className="">
                                                    <label className=" ">Calorific Value from<br></br> Seatrails (High CV)  </label>

                                                    <BootstrapInput className="smallbox1"
                                                        onChange={(e) => onFieldChange(e.target.value, "CvFromSeatrials")}
                                                    />  &nbsp;   MJ/kg

                                                </Box>
                                                <Box component="div" className="">
                                                    <label className=" ">BDR CV </label>

                                                    <BootstrapInput className="smallbox1"
                                                        onChange={(e) => onFieldChange(e.target.value, "BDR_CV")}
                                                    />&nbsp;   MJ/kg

                                                </Box>
                                                <Box component="div" className="">
                                                    <label className=" ">Total Fuel Consumed  </label>

                                                    <BootstrapInput value={""} readOnly disabled className="disabled smallbox1"
                                                        value={mgoresult.Total_ActualFOconsumed}
                                                    />  &nbsp;  Tonnes

                                                </Box>
                                            </form>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Box component="div" className="resultbox">
                                        <p>CO<sub>2</sub> based on ANNEX 5 MEPC66-21 245(66)</p>
                                        <Box component="div" className="bunkarinput wid180  mar25">
                                            <form className={classes.root} noValidate autoComplete="off">
                                                <Box component="div" className="">
                                                    <label style={{ width: '230px' }}>t-CO<sub>2</sub>/t-Fuel for MGO
                                                    </label>
                                                    <BootstrapInput className="smallbox1"
                                                        value={Mgo.CO2basedonAnnex_Mgo}
                                                    />
                                                </Box>
                                            </form>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={5}>

                                    <Box component="div" className="resultbox">
                                        <p>Results</p>

                                        <Box component="div" className="bunkarinput wid180  mar25">

                                            <form className={classes.root} noValidate autoComplete="off">
                                                {/* <Box component="div" className="">
                                                    <label style={{ width: '230px' }}>Calorific Value-Measured  </label>
                                                    <BootstrapInput value={"40.21"} readOnly className="smallbox1" /> &nbsp; CV

                                                </Box> */}
                                                <Box component="div" className="">
                                                    <label style={{ width: '230px' }}>CO<sub>2</sub> Emissions-Measured   </label>

                                                    <BootstrapInput disabled className="disabled smallbox1"
                                                        value={mgoresult.CO2_Emissions_Actaul}
                                                    /> &nbsp;  Tonnes &nbsp;  &nbsp;

                                                    {/* <BootstrapInput value={"40.21"} readOnly className="smallbox1" /> &nbsp; CV */}

                                                </Box>
                                                {/* <Box component="div" className="">
                                                    <label style={{ width: '230px' }}>Calorific Value from Seatrails (High CV)  </label>
                                                    <BootstrapInput value={"40.21"} readOnly className="smallbox1" /> &nbsp; CV

                                                </Box> */}
                                                <Box component="div" className="pt20">
                                                    <label style={{ width: '230px' }}>CO<sub>2</sub> Emissions-CV from Seatrials    </label>
                                                    <BootstrapInput readOnly disabled className="disabled smallbox1"
                                                        value={mgoresult.CO2_Emissions_High_CV_fuel}
                                                    /> &nbsp; Tonnes &nbsp;  &nbsp;

                                                    {/* <BootstrapInput value={"42.7"} readOnly className="smallbox1" />  &nbsp; CV */}


                                                </Box>
                                                <Box component="div" className="pt20">
                                                    <label style={{ width: '230px' }}>Excess CO<sub>2</sub>  </label>

                                                    <BootstrapInput readOnly disabled className="disabled smallbox1" style={{ background: 'rgb(230, 230, 230)' }}
                                                        value={mgoresult.Excess_CO2}
                                                    />  &nbsp;Tonnes &nbsp;  &nbsp;

                                                    {/* <BootstrapInput className="smallbox1" /> */}
                                                </Box>




                                            </form>
                                        </Box>



                                    </Box>
                                </Grid>


                                <Grid item xs={12} md={12}>
                                    <Box component="div" className="bunkarinput pt20">
                                        <button type="reset" className={classes.btn1} onClick={MgoReset} >Reset</button>
                                        <button type="button" className={classes.btn2} onClick={MgoCalculation} >Calculate</button>{''}
                                    </Box>

                                </Grid> </Grid></Grid></Grid>

                </Grid>

            </Box>
            {/* </TabPanel> */}
        </div>
        );
}
export default MGOCalculation;